function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5000 5000",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2500,
    cy: 2500,
    r: 2500,
    "data-name": "Red Button",
    style: {
      fill: "#35938b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2536.78 647C1796.08 647 1318 1140.77 1234 1855.2l725 105.06c21-309.93 141.82-661.9 514.81-661.9 262.65 0 436 162.86 436 425.51 0 236.39-120.83 357.2-299.43 488.54-457 336.2-472.79 409.76-472.79 971.85v99.81h677.66c-10.5-373 78.79-425.51 367.72-614.63C3519.11 2448.8 3766 2144.13 3766 1723.87 3766 1035.71 3177.66 647 2536.78 647m-444.01 3606h774v-789.85h-774Z",
    "data-name": "Icon",
    style: {
      fill: "#fff"
    }
  })));
};
export default SvgHelp;